import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Eleicao } from 'src/app/models/eleicao.model';
import { Resultado } from 'src/app/models/resultado.model';
import { ResultadosEleicao } from 'src/app/models/resultadosEleicao.model';
import { ResultadosService } from 'src/app/services/resultados.service';
import { GestoresService } from 'src/app/services/gestores.service';
import { ComprovanteService } from 'src/app/services/comprovante.service';
import { VotoService } from 'src/app/services/voto.service';
import { __param } from 'tslib';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { ComprovantePlanilhaDTO } from 'src/app/models/comprovantePlanilhaDTO.model';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import { VotosEleicao } from 'src/app/models/votosEleicao.model';
import { Voto } from 'src/app/models/voto.model';



@Component({
  selector: 'app-table-relatorio-votos',
  templateUrl: './table-relatorio-votos.component.html',
  styleUrls: ['./table-relatorio-votos.component.css']
})
export class TableRelatorioVotosComponent implements OnInit {

  public votos: Voto[] = [];
  public votosEleicao: VotosEleicao;
  public token: any;
  public totalVotos: number;
  public rastreabilidade: boolean;
  
  @Input() eleicaoId: number;
  logo: any;
  offset: number;
  
  constructor(
    protected resultadosService: ResultadosService,
    protected gestoresService: GestoresService,
    protected votoService: VotoService,
    protected comprovanteService: ComprovanteService,
    public spinner: NgxSpinnerService,
    protected router: Router,
    public utils: Utils
    ) {}
    
  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    this.getVotos(this.eleicaoId, this.token);
    // var logoRaw = sessionStorage.getItem("logoeleicao");
    // this.logo = logoRaw
  }

 async getVotos(idEleicao: number, token: any) {
    this.gestoresService.getRelatorioVotos(idEleicao, token).then((votos: VotosEleicao) => {
      this.votosEleicao = votos;
      this.votos = this.votosEleicao.votos.sort(sortBy('createdAt'));
      this.rastreabilidade = votos.rastreabilidade;
      this.spinner.hide();
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  somaTotalVotos(param:any){
    var sum = this.votos.length;
    return sum;
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  exportParaExcel(){
    let dadosResultado = this.votos
    this.utils.exportRelatorioVotosParaExcel(dadosResultado,this.votosEleicao.titulo, this.rastreabilidade);
  }

  separarDataHora(valor) {
    const dataHora = valor.createdAt.split("T");
    const separarHora = dataHora[1].split(".");
    const invertendoData = dataHora[0].split("-");
    const dataAno = invertendoData[0];
    const dataMes = invertendoData[1];
    const dataDia = invertendoData[2];
    const dataFormatada = dataDia + "/" + dataMes + "/" + dataAno

    return { data: dataFormatada, hora: separarHora[0] };}
}
